import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { AccessOrdererClient } from '@core/api';
import { FormlyFieldBaseService } from '@core/services/formly-service/formly-field.service';
import { FormlyPreviewAutocompleteProps } from '../formly-service/formly-service.types';

@Injectable({
  providedIn: 'root',
})
export class CostcenterEmployeeSearchFormlyFieldService extends FormlyFieldBaseService {
  override translatePath = 'contact.autocomplete';

  constructor(
    protected override translateService: TranslateService,
    private accessOrdererClient: AccessOrdererClient
  ) {
    super(translateService);
  }

  autocompleteSearch(
    placeholder: string,
    required?: boolean,
    visibleInConfirm?: boolean,
    currentUserEmail?: string,
    onSelect?: (id: string) => void,
    onDelete?: () => void,
    tooltip?: string
  ): FormlyFieldConfig[] {
    const translatePath = 'contact.autocomplete';

    const columnDefinitions = [
      {
        fieldName: 'fullName',
        labelTranslationKey: translatePath + '.name',
        classes: 'col-3',
      },
      {
        fieldName: 'phone',
        labelTranslationKey: translatePath + '.phone',
        classes: 'col-2',
      },
      {
        fieldName: 'mobilePhone',
        labelTranslationKey: translatePath + '.mobilePhone',
        classes: 'col-2',
      },
      {
        fieldName: 'company',
        labelTranslationKey: translatePath + '.company',
        classes: 'col-3, text-overflow',
      },
      {
        fieldName: 'orgUnit',
        labelTranslationKey: translatePath + '.orgUnit',
        classes: 'col-2; text-overflow',
      },
    ];
    const props: FormlyPreviewAutocompleteProps = {
      bindLabel: 'fullName',
      bindValue: 'id',
      required: required,
      visibleInConfirm: visibleInConfirm ?? false,
      translatePath,
      columnDefinitions,
      defaultValue: { id: currentUserEmail },
      onSearch: (searchText: string): Observable<any> => {
        return this.accessOrdererClient.searchCostCenterEmployees(searchText);
      },
      onSelect,
      onDelete,
      label: this.translateService.instant(placeholder),
      tooltip: tooltip,
    };

    return [
      {
        type: 'preview-autocomplete',
        key: 'searchResult',
        props: { ...props },
        validation: {
          messages: {
            required: this.translateService.instant('formErrors.contact.empty'),
          },
        },
      },
    ];
  }
}
